type SpeechResults = ArrayLike<{ isFinal: boolean; 0: { transcript: string } }>

// Text spoken so far in one Web Speech session, rebuilt from scratch on every
// event so re-reported results can't pile up. Cross-engine safe:
//  • Finalized text: concatenate the isFinal segments, but if a new final EXTENDS
//    the accumulated one, replace it — some engines (Android Chrome) re-send the
//    whole utterance as each new final instead of a fresh segment.
//  • In-progress text: only the LAST (interim) result. Android pushes each interim
//    snapshot as its own cumulative entry, so joining them all repeats the speech.
export function transcriptFromResults(results: SpeechResults): string {
  let finalText = ''
  for (let i = 0; i < results.length; i++) {
    if (!results[i].isFinal) continue
    const t = results[i][0].transcript.trim()
    if (!t) continue
    const acc = finalText.trim()
    finalText = acc && t.toLowerCase().startsWith(acc.toLowerCase()) ? `${t} ` : `${finalText}${t} `
  }
  const last = results.length > 0 ? results[results.length - 1] : undefined
  const interim = last && !last.isFinal ? last[0].transcript : ''
  return `${finalText}${interim}`.replace(/\s+/g, ' ').trim()
}
